/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import SubjectStepModel from 'cio/models/subject-step';

type SubjectStepDescriptionContentCreateEventActionArgs = {
  step: SubjectStepModel;
};

export default class SubjectStepDescriptionContentCreateEventAction extends Component<SubjectStepDescriptionContentCreateEventActionArgs> {
  get eventName() {
    let { status } = this.args.step;
    if (isEmpty(status?.createEvent?.name ?? '')) {
      // older subject steps do not have status
      return this.args.step.action.eventName;
    }
    return status?.createEvent?.name ?? '';
  }

  get createdForSomeoneElse() {
    let { status } = this.args.step;
    return status?.customerId != null && this.eventSuccess;
  }

  get personMerged() {
    let { status } = this.args.step;
    if (!this.createdForSomeoneElse) {
      return false;
    }
    return status?.merged;
  }

  get personId() {
    let { status, customerId } = this.args.step;

    // Older records or missing status data should not make links
    if (status == null) {
      return null;
    }

    if (status.customerId != null) {
      return status.customerId;
    }

    if (!status.isInternalIdentifier) {
      return null;
    }

    return customerId;
  }

  get eventSuccess() {
    let { status } = this.args.step;
    if (status?.createEvent == null) {
      // older subject steps do not have status and are assumed to have passed
      return true;
    }

    return !status.createEvent.hasFailures;
  }
}
